import { render, staticRenderFns } from "./EditFreeCourse.vue?vue&type=template&id=075acbb2&scoped=true"
import script from "./EditFreeCourse.vue?vue&type=script&lang=ts"
export * from "./EditFreeCourse.vue?vue&type=script&lang=ts"
import style0 from "./EditFreeCourse.vue?vue&type=style&index=0&id=075acbb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075acbb2",
  null
  
)

export default component.exports